// extracted by mini-css-extract-plugin
export default {"cell_increased-pd":"styles_cell_increased-pd__B3bW0"};